var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectedlaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.477,
    height: 61.365,
    viewBox: "0 0 75.477 61.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20736",
    "data-name": "Rectangle 20736",
    width: 75.477,
    height: 61.365,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31953",
    "data-name": "Group 31953",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31952",
    "data-name": "Group 31952",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22503",
    "data-name": "Path 22503",
    d: "M35.236,20.467a5.551,5.551,0,0,0-4.513,2.327L23.1,18.95a5.821,5.821,0,0,0,.073-3.682L30.855,11.4a5.528,5.528,0,1,0-.9-1.691l-7.641,3.852a5.874,5.874,0,1,0-.128,7.072l7.708,3.89a5.555,5.555,0,1,0,5.345-4.053m0-16.116a3.641,3.641,0,1,1-3.64,3.64,3.646,3.646,0,0,1,3.64-3.64M17.569,20.966a3.957,3.957,0,1,1,3.955-3.957,3.963,3.963,0,0,1-3.955,3.957m17.667,8.7a3.641,3.641,0,1,1,3.642-3.64,3.644,3.644,0,0,1-3.642,3.64",
    transform: "translate(10.652 2.218)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22504",
    "data-name": "Path 22504",
    d: "M64.358,38.726H3.94V0H64.358ZM7.762,34.9H60.536V3.822H7.762Z",
    transform: "translate(3.589 0.001)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22505",
    "data-name": "Path 22505",
    d: "M75.477,44.728H0V32.5L8.343,18.267H67.13L75.477,32.5ZM3.822,40.906H71.655V33.538L64.94,22.089h-54.4L3.822,33.538Z",
    transform: "translate(0 16.638)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20734",
    "data-name": "Rectangle 20734",
    width: 71.655,
    height: 3.822,
    transform: "translate(1.911 47.921)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20735",
    "data-name": "Rectangle 20735",
    width: 19.247,
    height: 3.822,
    transform: "translate(28.115 52.757)",
    fill: "#444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedlaptop);
export default __webpack_public_path__ + "static/media/connectedlaptop.3489337c605187e097d11b7fb5b46be3.svg";
export { ForwardRef as ReactComponent };